import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from 'react';
import { Header, Icon, Card, Button } from 'semantic-ui-react';
import Map from '../../atoms/Map';
import OutboundLink from '../../atoms/OutboundLink';
import { AddressPropType } from '../../services/proptypes';
import ContactElement from '../ContactElement';
import HoursOfOperation from '../HoursOfOperation';
import IconElement from '../IconElement';
import './location-as-card.css';

var Location = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Location, _React$PureComponent);

  var _super = _createSuper(Location);

  function Location() {
    _classCallCheck(this, Location);

    return _super.apply(this, arguments);
  }

  _createClass(Location, [{
    key: "getFormattedAddress",
    value: function getFormattedAddress() {
      var _this$createAddressCo = this.createAddressComponents(),
          street = _this$createAddressCo.street,
          locality = _this$createAddressCo.locality,
          country = _this$createAddressCo.country;

      return (street ? "".concat(street, ", ").concat(locality) : locality) + (country ? " ".concat(country) : '');
    }
  }, {
    key: "createAddressComponents",
    value: function createAddressComponents() {
      var address = this.props.address;
      var street = address.street,
          city = address.city,
          state = address.state,
          zip = address.zip,
          country = address.country;
      var locality = "".concat(city, ", ").concat(state, " ").concat(zip);
      return {
        street: street,
        locality: locality,
        country: country
      };
    }
  }, {
    key: "createMapLink",
    value: function createMapLink(type) {
      var businessName = this.props.businessName;
      var formattedAddress = this.getFormattedAddress(); // Link constants

      var linkBase = 'https://www.google.com/maps/search/?api=1&query=';
      var embedBase = 'https://maps.google.com/maps?q=';
      var embedTail = '&t=&z=13&ie=UTF8&iwloc=&output=embed'; // Address query

      var query = encodeURIComponent(businessName ? "".concat(businessName, " ").concat(formattedAddress) : formattedAddress); // Construct link

      if (type === 'link') return "".concat(linkBase).concat(query);
      return "".concat(embedBase).concat(query).concat(embedTail);
    }
  }, {
    key: "generateHumanReadableDistance",
    value: function generateHumanReadableDistance() {
      var _this$props = this.props,
          distance = _this$props.distance,
          distanceUnit = _this$props.distanceUnit;
      return distance && "".concat(distance.toFixed(2), " ").concat(distanceUnit === 'M' ? ' miles' : 'km', " away");
    }
  }, {
    key: "renderAddress",
    value: function renderAddress() {
      var _this$props2 = this.props,
          as = _this$props2.as,
          phone = _this$props2.phone,
          email = _this$props2.email,
          link = _this$props2.link,
          businessName = _this$props2.businessName,
          distance = _this$props2.distance,
          name = _this$props2.name,
          hours = _this$props2.hours,
          timezone = _this$props2.timezone,
          showBusinessName = _this$props2.showBusinessName,
          showAddress = _this$props2.showAddress,
          iconPosition = _this$props2.iconPosition,
          showIcon = _this$props2.showIcon,
          className = _this$props2.className,
          buttonColor = _this$props2.buttonColor,
          fluidButton = _this$props2.fluidButton,
          buttonText = _this$props2.buttonText,
          buttonSize = _this$props2.buttonSize,
          inline = _this$props2.inline,
          actions = _this$props2.actions;
      if (!showAddress) return ''; // Button values

      var additionalButtonProps = {
        buttonColor: buttonColor,
        fluidButton: fluidButton,
        buttonSize: buttonSize
      }; // Address values

      var _this$createAddressCo2 = this.createAddressComponents(),
          street = _this$createAddressCo2.street,
          locality = _this$createAddressCo2.locality,
          country = _this$createAddressCo2.country;

      if (as === 'card') {
        var linkProps = {};
        linkProps.href = this.createMapLink('link');
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
        return /*#__PURE__*/React.createElement(Card, {
          fluid: true,
          className: "location-as-card"
        }, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Card.Header, null, name || street), /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "map"
        })), /*#__PURE__*/React.createElement("div", null, street, /*#__PURE__*/React.createElement("br", null), locality, country && ", ".concat(country))), phone && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "phone"
        })), /*#__PURE__*/React.createElement("div", null, phone)), email && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "mail"
        })), /*#__PURE__*/React.createElement("div", null, email)), hours && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "calendar outline"
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HoursOfOperation, {
          hours: hours,
          timezone: timezone,
          displayOption: "dailyWithPopup"
        }))), distance && /*#__PURE__*/React.createElement(Card.Description, {
          className: "location-as-card-description"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          name: "world"
        })), /*#__PURE__*/React.createElement("div", null, this.generateHumanReadableDistance()))), /*#__PURE__*/React.createElement(Card.Content, {
          style: {
            display: 'flex',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/React.createElement(Button, {
          secondary: true,
          as: OutboundLink,
          to: linkProps.href,
          icon: "map",
          content: "Directions"
        }), phone && /*#__PURE__*/React.createElement(Button, {
          secondary: true,
          as: OutboundLink,
          to: "tel:".concat(phone),
          icon: "phone",
          content: "Call"
        }), email && /*#__PURE__*/React.createElement(Button, {
          secondary: true,
          as: OutboundLink,
          to: "mailto:".concat(email),
          icon: "mail",
          content: "Email"
        }), actions.map(function (_ref) {
          var icon = _ref.icon,
              url = _ref.url,
              label = _ref.label;
          return /*#__PURE__*/React.createElement(Button, {
            secondary: true,
            as: OutboundLink,
            to: url,
            icon: icon,
            content: label
          });
        })));
      }

      if (as === 'text') {
        var _linkProps = {};
        _linkProps.href = this.createMapLink('link');
        _linkProps.target = '_blank';
        _linkProps.rel = 'noopener noreferrer';
        var plainHeader = /*#__PURE__*/React.createElement("div", null, businessName && showBusinessName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, businessName), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("a", _extends({
          as: "a"
        }, _linkProps), /*#__PURE__*/React.createElement("span", null, street, !inline && /*#__PURE__*/React.createElement("br", null), locality, country && ", ".concat(country))), phone && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
          href: "tel:".concat(phone)
        }, phone)), email && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
          href: "mailto:".concat(email)
        }, email)), link && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
          href: link.url,
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: link.icon
        }), link.title)), distance && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, this.generateHumanReadableDistance())));
        return showIcon ? /*#__PURE__*/React.createElement(IconElement, {
          iconType: "map marker alternate",
          iconPosition: iconPosition,
          element: plainHeader
        }) : plainHeader;
      } // If not displaying the address, display as a button


      return /*#__PURE__*/React.createElement(ContactElement, _extends({
        contact: buttonText,
        link: this.createMapLink('link'),
        iconType: "map marker alternate",
        as: buttonText === '' ? 'icon' : 'button',
        className: className,
        content: buttonText
      }, additionalButtonProps));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var header = this.props.header;
      return /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement(Header, {
        as: "h2"
      }, header));
    }
  }, {
    key: "renderMap",
    value: function renderMap() {
      var _this$props3 = this.props,
          address = _this$props3.address,
          businessName = _this$props3.businessName;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/React.createElement(Map, {
        address: address,
        businessName: businessName
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          showMap = _this$props4.showMap,
          header = _this$props4.header,
          _this$props4$showAddr = _this$props4.showAddress,
          showAddress = _this$props4$showAddr === void 0 ? true : _this$props4$showAddr;
      return /*#__PURE__*/React.createElement(React.Fragment, null, header !== '' && this.renderHeader(), showAddress && this.renderAddress(), showMap && this.renderMap());
    }
  }]);

  return Location;
}(React.PureComponent);

export { Location as default };
Location.defaultProps = {
  as: 'text',
  businessName: '',
  showBusinessName: true,
  name: '',
  className: '',
  phone: null,
  email: null,
  link: null,
  hours: null,
  distance: null,
  timezone: '',
  distanceUnit: 'M',
  buttonColor: 'default',
  buttonSize: 'large',
  buttonText: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showAddress: true,
  showIcon: false,
  showMap: false,
  inline: false,
  actions: []
};
Location.propOptions = {
  buttonColor: ['primary', 'secondary', 'default'],
  header: ['Location', 'Our Location', ''],
  iconPosition: ['left', 'right', 'top', 'bottom']
};
Location.dataPropsMap = {
  address: ['business', 'primary_location', 'address'],
  // check this one
  businessName: ['business', 'primary_location', 'name']
};